module.exports = __webpack_public_path__ + "img/logo.69dd52fc.png";